import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./DropdownPopoverButton.module.css";

interface Props {
  displayValue: React.ReactNode;
  onShowPopover: () => void;
  minWidth?: number;
  className?: string;
  textClassName?: string;
  iconClassName?: string;
  disabled?: boolean;
  hideIcon?: boolean;
  placeholder?: string;
}

const DropdownPopoverButton: React.FC<Props> = ({
  displayValue,
  onShowPopover,
  minWidth,
  className,
  textClassName,
  iconClassName,
  disabled,
  hideIcon,
  placeholder,
}: Props) => {
  const noDisplayValue =
    displayValue === "" || displayValue === undefined || displayValue === null;

  return (
    <div
      className={toClassName(styles.container, className, {
        [styles.containerHover]: !disabled,
        [styles.containerDisabled]: disabled,
      })}
      style={minWidth ? { minWidth: `${minWidth}px` } : {}}
      onClick={onShowPopover}
    >
      {noDisplayValue && placeholder ? (
        <div
          className={toClassName(
            styles.displayValue,
            styles.displayValueDisabled,
            textClassName
          )}
        >
          {placeholder}
        </div>
      ) : (
        <div
          className={toClassName(styles.displayValue, textClassName, {
            [styles.displayValueDisabled]: disabled,
          })}
        >
          {displayValue}
        </div>
      )}

      {!hideIcon && (
        <ExpandMoreIcon
          className={toClassName(styles.icon, iconClassName, {
            [styles.iconDisabled]: disabled,
          })}
        />
      )}
    </div>
  );
};

export default DropdownPopoverButton;
